import React, { useEffect, useState } from "react";
import { Table, Button, Search, IconDownload } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import { numberFormatComma } from "../../../common/js/utils/numberFormat";
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import UploadModalDate from './UploadModalDate';
import XLSX from "xlsx";
import $ from 'jquery';

const RunLengthOldRender = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataRunLength, setDataRunLength] = useState([]);
    const [dataListRL, setDataListRL] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [datacounter, setdatacounter]=useState(1);

    //Metodos
    const fetchData = async () => {
        setDateSelected('');
        setDataRunLength([]);
        setDataListRL([]);

        connectApi.get(
            "api/Channels/AllTables",
            { params: { viewRequired: 'run_length' } },
            dataResponseLoad
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
        setLoadingData(true);
    };
    const dataResponseLoad = (status, data) => {
        setDateSelected( moment(data['date']).format("MM-DD-YYYY") );
        data['runLength'].forEach(x => {
            x.monthYear = moment(x.monthYear).format("MMM/DD/YYYY");
            x.startDate = moment(x.startDate).format("MMM/DD/YYYY");
            x.endDate = moment(x.endDate).format("MMM/DD/YYYY");
            x.tpi=numberFormatComma(
                x.tpi
                );
        })
        setDataRunLength(data['runLength'] === undefined ? [] : data['runLength']);
        // dataListGT dataListRL
        setDataListRL(data['dataListRL'] === undefined ? [] : data['dataListRL']);
        setLoadingData(false)
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
    }, [datacounter]);

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if (  orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } if( orderBy === "channel" || orderBy === "name" 
            || orderBy === "createdBy" || orderBy === "classification" 
            || orderBy === "description" || orderBy==="namecustomer" || orderBy==="nameEndUser" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate"
                || orderBy === "date" || orderBy === "monthYear" ){
   
                    
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }

    //Vista
    const [showModalRL, setShowModalRL] = useState(false);
    const [orderBy, setOrderBy] = useState("none");
    const [orderType, setOrderType] = useState("descending");
    const [nameFilter, setNameFilter] = useState("");
    const [channelFilter, setChannelFilter] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [ItemSelectRunLength, setItemSelectRunLength]=useState([]);
    const [ModifyValuesRunLength, setModifyValuesRunLength]=useState(false);
    const pageSize = 25;
    const [order, setOrder] = useState([
        'channel',
        'name',
        'idPress',
        'series',
        'classification',
        'description',
        'monthYear',
        'tpi',
        'createdBy',
        'startDate',
        'endDate',
    ]);
    const handlePageChange = (page) => setCurrentPage(page);
    const filteredData = filterSort(
        dataRunLength, {
            name: nameFilter,
            channel: channelFilter,
        },
        orderBy,
        orderType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    function setModalParameters(e){
        var channelRunLength = $(e.target).closest('tr').children().eq(0).text();
        var endUserName = $(e.target).closest('tr').children().eq(1).text();
        var pressid = $(e.target).closest('tr').children().eq(2).text();
        var serie = $(e.target).closest('tr').children().eq(3).text();
        var classifi = $(e.target).closest('tr').children().eq(4).text();
        var descrip = $(e.target).closest('tr').children().eq(5).text();
        var monthyearRunLength = $(e.target).closest('tr').children().eq(6).text();
        var tpi = $(e.target).closest('tr').children().eq(7).text();
        var startdateRunLength = $(e.target).closest('tr').children().eq(9).text();
        var enddateRunLength = $(e.target).closest('tr').children().eq(10).text();


        if( channelRunLength !== 'Channel ' & endUserName !== 'End user' & pressid!=='Press ID' & serie!=='Series' & classifi !== 'Classification' &  descrip !== 'Description' 
        & monthyearRunLength!=='Month Year' & tpi !== 'TPI' & startdateRunLength!=='Start date' & enddateRunLength !=='End date'
        & new Date(dateSelected) <= new Date(monthyearRunLength) ){
            let vaItem = dataRunLength.find(gt => gt.channel === channelRunLength & gt.name === endUserName & gt.monthYear===monthyearRunLength & gt.tpi===tpi);
            setItemSelectRunLength(vaItem);
            setModifyValuesRunLength(true);
            setShowModalRL(true);
        }
    };
    return (
        <div>
            <div>
                <Table
                    onClick={setModalParameters}
                    columns = {[
                        {
                            id: 'channel',
                            label: t("channel"),
                            filter: (
                                <Search
                                    id="channel-filter"
                                    value={channelFilter}
                                    onChange={(val) => {
                                        setChannelFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'name',
                            label: t("endUser"),
                            filter: (
                                <Search
                                    id="name-filter"
                                    value={nameFilter}
                                    onChange={(val) => {
                                        setNameFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'idPress',
                            label: t("press id")
                        },
                        {
                            id: 'series',
                            label: t("series")
                        },
                        {
                            id: 'classification',
                            label: t("classification")
                        },
                        {
                            id: 'description',
                            label: t("Description")
                        },
                        {
                            id: 'monthYear',
                            label: t("monthYear")
                        },
                        {
                            id: 'tpi',
                            label: "TPI"
                        },
                        {
                            id: 'createdBy',
                            label: t("created_by")
                        },
                        {
                            id: 'startDate',
                            label: t("specialcondition.startdate")
                        },
                        {
                            id: 'endDate',
                            label: t("specialcondition.enddate")
                        },
                    ]}
                    showFilters
                    columnReorder
                    data={pagedData}
                    loading={loadingData}
                    onSort={handleSort}
                    onColumnReorder={(reOrder) => setOrder(reOrder)}
                    preferences={{
                        defaultOrder: order,
                        sortBy: {
                            id: orderBy,
                            type: orderType,
                        },
                        order: order
                    }}
                    pagination={{
                        currentPage,
                        onPageChange: handlePageChange,
                        pageSize,
                        totalItems: filteredData.length,
                    }}
                />
                <div style={{ textAlign: "left" }}>
                    <Button
                        onClick={()=>{
                            setTimeout(() => {
                            const dataXlsx = filteredData.map((item) => { return item; });
                            const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                            const wb = XLSX.utils.book_new();
                            const date = moment(new Date()).format('YYYYMMDDHHmm');
                            const filename = 'RunLength-' + date + '.xlsx';
                            const ws_name = "RunLength";
                            XLSX.utils.book_append_sheet(wb, ws, ws_name);
                            XLSX.writeFile(wb, filename);
                            }, 750);
                        }}
                        disabled={filteredData.length === 0}
                        leadingIcon={<IconDownload />}
                        title={t('download data')}
                        >
                        {t('download')}
                    </Button>
                </div>
            </div>
            <UploadModalDate
                key={showModalRL ? true : false}
                showModal={showModalRL}
                setShowModal={setShowModalRL}
                tabView="run_Length"
                dataList={dataListRL}
                dateInit={dateSelected}
                fetchData={useEffect}
                valueModify={ModifyValuesRunLength}
                setValueModify={setModifyValuesRunLength}
                itemModify={ItemSelectRunLength}
                datacounter={datacounter}
                setdatacounter={setdatacounter}
            />
        </div>
    );
}

export default RunLengthOldRender;
